module.exports = __webpack_public_path__ + "static/media/rogaland2.965d61f5.jpg";